import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=3112dd82&"
import script from "./SettingsModal.vue?vue&type=script&lang=js&"
export * from "./SettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports